import api from "@/services/api";

const initialState = () => ({
  user: {
    avatar:
      "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg",
    displayName: "",
    description: "",
    address: "",
    websiteUrl: "",
    twitterUsername: "",
    email: "",
  },
  currentPage: 1,
  nftsList: { total: 0 },
  externalNftsList: { total: 0 },
  poolsList: { total: 0 },
  nftDataList: [],
  externalNftDataList: [],
  externalNftsToShowList: [],
  poolsDataList: [],
  errors: [],
});

const state = initialState();

const getters = {
  getByKey: (state) => (key) => state[key],
  getUser: (state) => state.user,
};

const mutations = {
  commitByKey(state, object) {
    Object.keys(object).forEach((key) => (state[key] = object[key]));
  },
  pushError(state, error) {
    state.errors.push(error);
  },
  clearNftList(state) {
    state.nftsList = { total: 0 };
  },
  clearExternalNftList(state) {
    state.externalNftsList = { total: 0 };
  },
  clearPoolsList(state) {
    state.poolsList = { total: 0 };
  },
  setNftDataList(state, list) {
    state.nftDataList = state.nftDataList.concat(list);
  },
  setExternalNftDataList(state, list) {
    state.externalNftDataList = state.externalNftDataList.concat(list);
  },
  setExternalNftsToShowList(state, list) {
    state.externalNftsToShowList = state.externalNftsToShowList.concat(list);
  },
  clearExternalNftsToShowList(state) {
    state.externalNftsToShowList = [];
  },
  setPoolsDataList(state, list) {
    state.poolsDataList = state.poolsDataList.concat(list);
  },
  clearNftDataList(state) {
    state.nftDataList = [];
  },
  clearExternalNftDataList(state) {
    state.externalNftDataList = [];
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
};
const actions = {
  commitByKey({ commit }, object) {
    commit("commitByKey", object);
  },
  async fetchNftList({ commit }, { params }) {
    try {
      const response = await api.fetchNftList(params);
      commit("commitByKey", { nftsList: response.data });
      commit("setNftDataList", response.data.data);
    } catch (error) {
      commit("pushError", error);
    }
  },
  async fetchExternalNftList({ commit, state }, parameters) {
    try {
      if (!state.externalNftsList.data || state.externalNftsList.hasNextPage) {
        const response = await api.fetchExternalNftList(parameters);
        commit("commitByKey", { externalNftsList: response.data });
        commit("setExternalNftDataList", response.data.data);
      }
      commit(
        "setExternalNftsToShowList",
        state.externalNftDataList.splice(0, 6)
      );
    } catch (error) {
      commit("pushError", error);
    }
  },
  async fetchPools({ commit }, { params }) {
    try {
      const response = await api.fetchPools(params);
      commit("commitByKey", { poolsList: response.data });
      commit("setPoolsDataList", response.data.data);
    } catch (error) {
      commit("pushError", error);
    }
  },
  async fetchMe({ commit }) {
    try {
      const response = await api.fetchMe();
      commit("commitByKey", { user: response.data.data });
      return response;
    } catch (error) {
      commit("pushError", error);
    }
  },
  resetState({ commit }) {
    commit("resetState");
  },
  clearNftList({ commit }) {
    commit("clearNftList");
  },
  clearNftDataList({ commit }) {
    commit("clearNftDataList");
  },
  clearExternalNftList({ commit }) {
    commit("clearExternalNftList");
  },
  clearExternalNftDataList({ commit }) {
    commit("clearExternalNftDataList");
    commit("clearExternalNftsToShowList");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
